// Card types and utilities

export type Rank = 'A' | 'K' | 'Q' | 'J' | 'T' | '9' | '8' | '7' | '6' | '5' | '4' | '3' | '2';
export type Suit = 's' | 'h' | 'd' | 'c';

export interface Card {
  rank: Rank;
  suit: Suit;
}

export const RANKS: Rank[] = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
export const SUITS: Suit[] = ['s', 'h', 'd', 'c'];

// Rank index: A=0, K=1, ... 2=12
export const RANK_INDEX: Record<Rank, number> = Object.fromEntries(
  RANKS.map((r, i) => [r, i])
) as Record<Rank, number>;

export function parseCard(s: string): Card | null {
  if (!s || s.length < 2) return null;
  const rank = s[0].toUpperCase() as Rank;
  const suit = s[1].toLowerCase() as Suit;
  if (!RANKS.includes(rank) || !SUITS.includes(suit)) return null;
  return { rank, suit };
}

export function cardToString(c: Card): string {
  return `${c.rank}${c.suit}`;
}

export function cardsEqual(a: Card, b: Card): boolean {
  return a.rank === b.rank && a.suit === b.suit;
}

/** Parse a space-delimited card string like "Ah Kd 9c" */
export function parseCards(s: string): Card[] {
  return s.trim().split(/\s+/).map(parseCard).filter((c): c is Card => c !== null);
}
